import React from "react";
import Home from "../Home/Home";

const HomePage = () => {
  return <>
    <Home />
  </>;
};

export default HomePage;
